import React, { useContext } from 'react';
import Tooltip from '@mui/material/Tooltip';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { ConfigContext } from '../../Context/ConfigContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { checkForEmptyNotes } from "../../helper/helpersSubModule";
import { renderAlert } from '../../../../CommonComponents/Alert/Alert';
import { applyStylestoCellRenderer } from '../../helper/helperFunctions';
import xTablesStore from '../../redux/xTablesStore';
import azureDevOpsIcon from '../../../../../build/assets/images/azure_devops_icon.png';
import store from '../../../../redux/store';
import './CustomCellRenderer.css'
import { normalizeUrl } from './customCellRendererHelper';
const CustomCellRenderer = (params) => {

  let value = params.value || '';
  const { corruptedNodes,setCorruptedNodes } = useContext(ConfigContext)

    if(!params.node.data){
      if(corruptedNodes.length==0){
        params?.api?.showLoadingOverlay()
        setCorruptedNodes([...corruptedNodes,params.node]);
      }
    }
  // Customize the rendering of the cell based on the value or any other logic

  if (typeof value === "object" && typeof value.getMonth === 'function') {
    value = new Date(value).toISOString()
  }
  let showTooltip = false;

  const isWrapped = params.data ? params.data.wrap : false
  let colWidth = parseInt(params.colDef.width) - 50
  if (params.colDef.colId !== '#' && value) {
    let indentationLevel = params.data?.l_id?.split('.').length ?? 1
    if (indentationLevel > 1 && params.colDef.colId === 'ag-Grid-AutoColumn') {
      if (indentationLevel < 4) colWidth -= (indentationLevel - 1) * 25
      else colWidth -= (indentationLevel - 1) * 20
    }
  }
  
  const isPrimaryCol = params.colDef.colId === 'ag-Grid-AutoColumn'
  const isParent=isPrimaryCol && params?.node?.allLeafChildren?.length > 0;
  let paddingLeft
  if(isPrimaryCol && !value  && params.node.rowIndex &&(params.node.allChildrenCount==0 || params.node.allChildrenCount===null ) ){    
    let previousRow=params.api?.getModel()?.rowsToDisplay[params.node.rowIndex-1]
    if(previousRow && previousRow.data && previousRow?.data?.l_id?.includes('.')){
      let indentationLevel=previousRow?.data?.l_id?.split('.').length ?? 1
      let myIndentationLevel=params.node?.data?.l_id?.split('.').length ??1
      paddingLeft=(indentationLevel-myIndentationLevel)*22
    }
  }

  let columnName=params.colDef.field+"_es"
  let cellFormat = params.data ? params.data[columnName]?.format : '';
  const cellStyles = applyStylestoCellRenderer(cellFormat);
  const field = params?.colDef?.field;
  const extraField = field ? `${field}_es` : null;
  const hasNotes = extraField && params?.data?.hasOwnProperty(extraField) &&
    params?.data[extraField] !== undefined &&
    !checkForEmptyNotes(params?.data[extraField]?.notes);

  const handleIconClick = (e) => {
    e.stopPropagation(); // prevent triggering other events
    if (params?.onClickOpenRightDrawer) {
      params.onClickOpenRightDrawer("notes", 0);
    }
  };

  const rawHyperlink = params?.data?.[columnName]?.hyperlink;
  let hyperlinkUrl = null;

  if (typeof rawHyperlink === 'string' && rawHyperlink.trim() !== '') {
    hyperlinkUrl = rawHyperlink.trim();
  } else if (rawHyperlink && typeof rawHyperlink === 'object' && typeof rawHyperlink.url === 'string') {
    hyperlinkUrl = rawHyperlink.url.trim();
  }

  const normalizedHyperlinkUrl = hyperlinkUrl ? normalizeUrl(hyperlinkUrl) : null;
  const hasHyperLink = Boolean(normalizedHyperlinkUrl);

  const openLink = (event, url) => {
    event.stopPropagation();
    try {
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      window.location.href = url;
    }
  };

  const labelToShow =
    value !== null && value !== undefined && String(value).trim() !== ''
      ? String(value)
      : '';


      return (
        <div
          className={`cell-root ${isWrapped ? 'wrapped' : ''} ${isPrimaryCol ? 'primary-col' : ''} ${isParent ? 'bold' : ''}`}
          style={{
            paddingLeft,
            // ...(isPrimaryCol && colWidth > 20 ? { width: colWidth + 'px' } : {}),
          }}
        >
          <span className="blinkingCursor"></span>
      
          {hasHyperLink ? (
            <Tooltip title={normalizedHyperlinkUrl} placement="left" arrow disableInteractive>
              <a
                href={normalizedHyperlinkUrl}
                onClick={(e) => {
                  e.preventDefault();
                  openLink(e, normalizedHyperlinkUrl);
                }}
                className="cell-hyperlink"
                tabIndex={-1}
              >
                {labelToShow}
              </a>
            </Tooltip>
          ) : isWrapped ? (
            <span
              className="cell-text-wrap"
              style={typeof value === 'string' && value.includes('\n') ? { whiteSpace: 'pre-wrap' } : undefined}
            >{value}</span>
          ) : typeof value === 'string' && value.includes('\n') ? (
            <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>
          ) : showTooltip ? (
            <Tooltip title={value} placement="left" arrow disableInteractive>
              <span className="cell-text-nowrap">{value}</span>
            </Tooltip>
          ) : (
            <span className="cell-text-nowrap">{value}</span>
          )}
      
          {hasNotes && (
            <ArrowDropDownIcon
              className="notes-icon"
              onClick={(e) => {
                e.stopPropagation();
                handleIconClick(e);
              }}
            />
          )}
        </div>
      );}
export default CustomCellRenderer;



export const IndicatorRenderer = ({ readOnlyMode, openMenuFnOptionsMenu, onClickOpenRightDrawer, ...params }) => {
  let {isFilterOrSummaryViewActive} = xTablesStore.getState().gridReducer
  const currentSheet = store.getState().sheetReducer?.currentSelectedSheet;
  const isNodeEmpty = (node) => {
    if ('text' in node) {
      return node.text === '';
    }

    if ('children' in node) {
      return node.children.every(isNodeEmpty);
    }

    return false;
  };

  const areAllNodesEmpty = (nodes) => {
    return nodes.every(isNodeEmpty);
  };
  const checkForEmptyNotes = (content) => {
    if (content === "Notes example") return false
    if (content.startsWith("[{")) {
      const parsedContent = JSON.parse(content)
      return !areAllNodesEmpty(parsedContent)
    }
    return true
  }

  const handleClick = (e) => {
    if (params.data.checkinagent) {
      renderAlert("Notes cannot be added to data sourced from the HRMS application.", 'info');
    }
    else if (params.data.isAzureRow) {
      renderAlert("Notes cannot be added to data sourced from the Azure application.", 'info');
    }
    if (currentSheet?.sheetType === 'filterSheet') {
      return
    }
    else { onClickOpenRightDrawer("notes", 0); }
  }

  const handleAttachmentClick = () => {
    if(params.data.checkinagent){
      renderAlert("Attachments cannot be added to data sourced from the HRMS application.",'info'); 
    }
    else if(params.data.isAzureRow){
      renderAlert("Attachment cannot be added to data sourced from the Azure application.",'info'); 
    }
    if(currentSheet?.sheetType==='filterSheet'){
      return;
    }
   else {
      onClickOpenRightDrawer("attachment", 0);
    }
  };
  return (
    <div className="myComponentContainer" >
  
      {params.value}
      {(params.data?.attachments?.length > 0 ?
        <AttachFileOutlinedIcon className="attachmentIcon" onClick={handleAttachmentClick} /> : <AttachFileOutlinedIcon className='indicator-icon' style={{cursor:readOnlyMode||currentSheet?.sheetType==='filterSheet'?"default":"pointer"}} onClick={handleAttachmentClick} />
      )}
      {(params.data?.notes && checkForEmptyNotes(params.data.notes) ?
        <EditNoteOutlinedIcon className="noteIcon" onClick={(e) => { handleClick(e) }} /> : <EditNoteOutlinedIcon className='indicator-icon'style={{cursor:readOnlyMode||currentSheet?.sheetType==='filterSheet'?"default":"pointer"}} onClick={(e) => { handleClick(e) }} />
      )}
     
      <i className="fa fa-ellipsis-v optionsIcon" style={{ padding: '0px 3px', cursor:readOnlyMode ||isFilterOrSummaryViewActive?"default":"pointer"}} onClick={(e) => { !readOnlyMode && !isFilterOrSummaryViewActive && openMenuFnOptionsMenu(e, params) }} aria-hidden="true"></i>
      {params?.node?.data?.isAzureRow && <img
        src={azureDevOpsIcon}
        alt='axure'
        style={{ height: '0.6rem', width: '0.75rem', fontSize: '20px' }} />
      }
    </div>
  );
}
